import { Component, OnInit } from '@angular/core';
import { UserService } from "../../services/user.service";
import { LoginComponent } from "../login/login.component";
import { User } from "../../models/user";
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MovimientosComponent } from 'src/app/modales/movimientos/movimientos.component';
declare var $: any;

@Component({
  selector: 'app-ahorros',
  templateUrl: './ahorros.component.html',
  styleUrls: [
    './ahorros.component.css',
    '../login/perfect-scrollbar/dist/css/perfect-scrollbar.min.css',
    '../login/css/table.css',
    '../login/css/estilos.css'
  ],
  providers: [UserService]
})
export class AhorrosComponent implements OnInit {
  public user: User;
  public ahorrosAsociado;
  public ahorros;
  public mvtoahorros;
  public identity;
  public token;
  paginaactual: number = 1;
  actual = environment.actual;
  public colorFondo = environment.entidad[this.actual].colorMenu;
  public letraColor = environment.entidad[this.actual].letraColor;
  public ahorrosConfig
  public mobile

  constructor(
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
  ) {
    this.user = new User(1, '', '', '', '', '', '', 0, 0);
  }

  ngOnInit() {
    this.spinner.show();
    this.identity = JSON.parse(this._userService.GetsessionStorage('identity'));
    this.ahorrosConfig = JSON.parse(this._userService.GetsessionStorage('config'));
    this.consultAhorros()
    if (window.screen.width > 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  decodeBuffer(arraybuffer?) {
    if (arraybuffer != null) {
      return String.fromCharCode.apply(null, new Uint16Array(arraybuffer));
    }
  }

  consultAhorros() {
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year + '-' + (monthIndex + 1) + '-' + day
    };
    this._userService.httpPost('ahorros', data).subscribe(
      response => {
        if (response.status != 'error') {
          this.ahorrosAsociado = response.details;
        } else {
          console.log(response.details)
        }
        this.spinner.hide()
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    );
  }
  movimientoAhorros(codahorro) {
    this.spinner.show();
    this.mvtoahorros = [];
    this.paginaactual = 1;
    this._userService.httpGet('mvtoahorros/'+codahorro).subscribe(
      response => {
        this.mvtoahorros = response;
        if (this.mobile) {
          this.scrollTOElement('#target', 300, 500);
        } else {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = false;
          dialogConfig.width = '100%';
          const modalRef = this.dialog.open(MovimientosComponent, {
            autoFocus: false,
            maxHeight: '80vh',
            width: '100%', //you can adjust the value as per your view
            data: { datos: this.mvtoahorros, modulo: 'mvtoahorros', op: 1 }
          });

          modalRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
        this.spinner.hide()
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    );
  }

  scrollTOElement = (element, offsetParam?, speedParam?) => {
    const toElement = $(element);
    const focusElement = $(element);
    const offset = offsetParam * 1 || 200;
    const speed = speedParam * 1 || 500;
    $('html, body').animate({
      scrollTop: toElement.offset().top + offset
    }, speed);
    if (focusElement) {
      $(focusElement).focus();
    }
  }

}
